import httpClient from './httpClient'

export class E2eSimulationApi {
  static async create(form) {
    try {
      const res = await httpClient.post('/e2e_simulation', form)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}

export default E2eSimulationApi
